import store from '../../store'
import notif from "./notif.vue";

window.IMC_VUE_SYS =  new Vue({
	store,
	el: '#imc_notif',
	name : "IMC_BILLING",
	data () {
		return {

		}
	},
	created () {

	},
	components : {
		notif
	}

});
